import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { toast } from 'react-toastify';
import _ from 'lodash';
import RSelect from 'react-select';
import Textarea from 'react-expanding-textarea';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, MARK_IGNORED_DATA, Revert_Ignored_DATA } from '../../../../appRedux/actions/ReportDetailAction';
import { LedgerUpdate } from '../../../../appRedux/actions/LedgerAction';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import { ReportType, numberWithCommas, makeLinkForQuickbooks, ModuleType, LinkType } from '../../../common/commonServices';
import CommonComments from './../../../common/Comments';
import '../../styles.css';
import './DataEntryIssues.css';
import './TrainingTipTables.css';

// UseVendorPayeeForPayments (ReportType 52) — Got It ignore; SAVE via QuickbookGeneralLedger (LedgerUpdate) like TBR
class UseVendorPayeeForPayments extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#e27b40",
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            IsIgnoredFilter: false,
            IsCommentModelOpen: false,
            editIndex: -1,
            editData: null,
            selectedAccount: null,
            accounts: [],
            DisplayAccounts: []
        }
    }

    onCheckboxClick = (e, item) => {
        e.stopPropagation();

        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.id) > -1) {
            existInArray = true;
        }

        if (e.target.checked) {
            if (!existInArray) {
                data.push(item.id);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.id), 1);
            }
        }

        let all = (data.length == this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all });
    }

    SelectALL = (e) => {
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].id);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }

    OnApplyIgnore = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }

        let body = {
            "ids": selectedData,
            "reportType": ReportType.UseVendorPayeeForPayments,
            "companyID": this.state.companyId
        }

        this.setState({ loading: true }, () => {
            if (this.state.IsIgnoredFilter) {
                this.props.Revert_Ignored_DATA(body);
            }
            else {
                this.props.MARK_IGNORED_DATA(body);
            }
        });
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.Accounts(this.state.companyId);
            this.GetReportData();
        });
    }

    onLinkClick = (e, rowData) => {
        e.stopPropagation();
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }

    LoadComments = (e, item) => {
        e.stopPropagation();
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {
            if (item.id === id) {
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            }
        });
        this.setState({ MissingData: data });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField === fieldName) {
            let formate = this.state.sortFormat === 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    // Refresh Data disabled for Vendor Payee DEI (keep for rollback).
    // onRefreshDataClick = () => {
    //     if (!this.state.loading) {
    //         this.setState({ loading: true }, () => {
    //             this.GetReportData(true);
    //         });
    //     }
    // }

    ChangePageSize = (size) => {
        this.setState({
            loading: true, PageSize: parseInt(size), PageNo: 1, SelectedRecords: [],
            SelectALL: false, editIndex: -1, editData: null
        }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({
            loading: true, PageNo: page, SelectedRecords: [],
            SelectALL: false, editIndex: -1, editData: null
        }, () => {
            this.GetReportData();
        });
    }

    onRowClick = (j, item) => {
        let selectedAccount = null;
        if (item.newAccountId) {
            selectedAccount = this.state.DisplayAccounts.find(x => String(x.value) === String(item.newAccountId)) || null;
        }
        this.setState({
            editIndex: j,
            editData: {
                accountantComment: item.accountantComment || '',
                newAccountId: item.newAccountId || '',
                newAccountName: item.newAccountName || '',
                memoOrDescription: item.memoOrDescription || ''
            },
            selectedAccount: selectedAccount
        });
    }

    onRowCancel = () => {
        this.setState({ editIndex: -1, editData: null, selectedAccount: null });
    }

    // New Account # — "{number} {name}" (number omitted when empty); resolve from API or accounts list
    formatAccountLabel = (accountNumber, accountName) => {
        const num = (accountNumber != null && accountNumber !== '') ? String(accountNumber).trim() : '';
        const name = (accountName != null && accountName !== '') ? String(accountName).trim() : '';
        if (num && name) {
            // Avoid "08 08 Petty Cash" when API already returned CONCAT_WS number+name
            if (name === num || name.startsWith(num + ' ')) return name;
            return `${num} ${name}`;
        }
        return num || name || '';
    }

    formatNewAccountLabel = (item) => {
        if (!item) return '';
        const fromApi = item.newAccountName != null ? item.newAccountName : item.NewAccountName;
        // SP CONCAT_WS already includes number when present
        if (fromApi != null && String(fromApi).trim() !== '') {
            const trimmed = String(fromApi).trim();
            // If API returned name-only, enrich from accounts list
            const id = item.newAccountId != null ? item.newAccountId : item.NewAccountId;
            if (id && this.state.accounts && this.state.accounts.length > 0) {
                const acc = this.state.accounts.find(x => x.accountID == id);
                if (acc && acc.accountNumber != null && String(acc.accountNumber).trim() !== '') {
                    const num = String(acc.accountNumber).trim();
                    if (!trimmed.startsWith(num + ' ') && trimmed !== num) {
                        return this.formatAccountLabel(num, trimmed);
                    }
                }
            }
            return trimmed;
        }
        const id = item.newAccountId != null ? item.newAccountId : item.NewAccountId;
        if (id && this.state.accounts && this.state.accounts.length > 0) {
            const acc = this.state.accounts.find(x => x.accountID == id);
            if (acc) return this.formatAccountLabel(acc.accountNumber, acc.name);
        }
        return '';
    }

    handalTextArea = (e) => {
        let editData = { ...this.state.editData };
        editData[e.target.name] = e.target.value;
        this.setState({ editData: editData });
    }

    handalAccountDropdown = (e) => {
        if (e.value == null || e.value == 0) {
            let editData = { ...this.state.editData };
            editData.newAccountId = '';
            editData.newAccountName = '';
            this.setState({ editData: editData, selectedAccount: e });
        }
        else {
            let obj = this.state.accounts.find(x => x.accountID == e.value);
            let editData = { ...this.state.editData };
            editData.newAccountId = e.value;
            editData.newAccountName = obj ? this.formatAccountLabel(obj.accountNumber, obj.name) : e.label;
            this.setState({ editData: editData, selectedAccount: e });
        }
    }

    onRowSave = (item) => {
        let newAccountId = this.state.editData.newAccountId;
        let finalNewAccountId = 0;
        if (newAccountId && newAccountId > 0) {
            finalNewAccountId = Number(newAccountId);
        }

        // Same QuickbookGeneralLedger payload pattern as Transactions to be Reviewed (memo left unchanged — no QBO memo sync)
        let data = {
            id: item.id,
            transactionTypeId: item.transactionTypeId || 0,
            transactionType: item.transactionType,
            accountId: item.accountId || 0,
            newAccountId: finalNewAccountId,
            needsBetterDescription: item.needsBetterDescription || false,
            transferCodedIncorrectly: item.transferCodedIncorrectly || false,
            cpaReview: item.cpaReview || false,
            pcCheck: item.pcCheck || false,
            accountantComment: this.state.editData.accountantComment,
            internalNotes: item.internalNotes || '',
            taxableFringeBenefit: item.taxableFringeBenefit || false,
            vendor1099: item.vendor1099 || false,
            taxReporting: item.taxReporting || false,
            isArchived: item.isArchived || false,
            benefitTypeId: item.benefitTypeId || 0,
            employeeName: item.employeeName || '',
            clientComment: item.clientComment || '',
            accountChangeApprovedByClient: item.accountChangeApprovedByClient || false,
            clientReviewStatus: item.clientReviewStatus || false,
            accountantReviewStatus: item.accountantReviewStatus || false,
            descriptionNeedsEmployeeName: item.descriptionNeedsEmployeeName || false,
            clientApprovedTaxableFringeBenefit: item.clientApprovedTaxableFringeBenefit || false,
            accountantPostedTaxableFringeBenefit: item.accountantPostedTaxableFringeBenefit || false,
            memoOrDescription: item.memoOrDescription
        };

        this.setState({ loading: true }, () => {
            this.props.LedgerUpdate(data, this.state.companyId, "Transaction updated successfully.");
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }
                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false, SelectALL: false, SelectedRecords: [], editIndex: -1, editData: null });
            } else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }

        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                this.setState({
                    loading: true, SelectALL: false, SelectedRecords: []
                }, () => {
                    toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                    this.GetReportData();
                });
            }
            else {
                this.setState({ loading: false }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.LEDGER_UPDATE !== undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            if (nextProps.LEDGER_UPDATE.transactionStatus === 0) {
                this.setState({
                    loading: false,
                    editIndex: -1,
                    editData: null,
                    selectedAccount: null,
                    SelectALL: false,
                    SelectedRecords: []
                }, () => {
                    toast.success("Transaction updated successfully");
                    this.GetReportData();
                });
            }
            else {
                this.setState({
                    loading: false,
                    editIndex: -1,
                    editData: null,
                    selectedAccount: null
                }, () => {
                    toast.error(nextProps.LEDGER_UPDATE.resultMsg || "Update failed");
                });
            }
        }

        if (nextProps.accounts !== this.props.accounts) {
            if (nextProps.accounts && nextProps.accounts.data != null && nextProps.accounts.data.length > 0) {
                let searchableAccounts = _.sortBy(nextProps.accounts.data, ['accountNumber', 'name']).map((value) => (
                    { value: value.accountID, label: (value.accountNumber != null ? value.accountNumber + ' ' + value.name : value.name) }
                ));
                searchableAccounts.unshift({ value: 0, label: 'Select' });
                this.setState({
                    accounts: nextProps.accounts.data,
                    DisplayAccounts: searchableAccounts
                });
            }
        }
    }

    GetReportData = (IsRefresh = false) => {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.UseVendorPayeeForPayments,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh,
            IsIgnore: true,
            isAllIgnoreUnignore: state.IsIgnoredFilter
        };

        this.props.GET_REPORT_DATA(body);
    }

    HandleIgnored = (event) => {
        // Reset to page 1 so filter switch does not keep an out-of-range PageNo (empty result).
        this.setState({ IsIgnoredFilter: (event.target.value == "true" ? true : false), PageNo: 1, loading: true, SelectedRecords: [], SelectALL: false, editIndex: -1, editData: null }, () => { this.GetReportData() });
    }

    render() {
        let selectedItem = this.state.SelectedRecords;
        return (
            <div className="dashboardPage data-entry-issues-page use-vendor-payee-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.UseVendorPayeeForPayments}</h2>
                </div>
                {this.state.IsCommentModelOpen ? <CommonComments
                    CloseComments={this.CloseComments}
                    ColorCode={this.state.ColorCode}
                    ModuleType={ModuleType.GeneralReportType}
                    ReportType={ReportType.UseVendorPayeeForPayments}
                    CompanyId={this.state.companyId}
                    RecordId={this.state.CommentReferenceId}
                    IsEmbeddedPage={this.state.IsEmbeddedPage}
                    UpdateItemCommentCount={this.UpdateItemCommentCount}
                    SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } }}
                ></CommonComments> : ""}
                {this.state.loading ? <div className="dei-loader-box"><CircularProgress /></div>
                    :
                    <React.Fragment>
                        <div className="padding-box app-wrapper">
                            <div className="row mt-1">
                                <div className="col-md-7">
                                    <div className="dei-tip-block">
                                        <h5 className="dei-training-tip" >Be sure to use the "Vendor" payee type when recording payments to vendors.</h5>
                                        <h5 className="dei-training-tip dei-tip-gap" >Use the "Customer" or "Donor" payee type when issuing a refund for sales, activity or event fees.</h5>
                                        <h5 className="dei-training-tip" >You do not need to change these transactions, unless they are payments for 1099 vendors or for payroll to an employee.</h5>
                                        <h5 className="dei-training-tip" >Select the entries and click "Got it!" to confirm you will make sure future payments are assigned to a vendor.</h5>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className='d-flex justify-content-end align-items-end h-100'>
                                        <div className='d-flex align-items-center'>
                                            <div className='show-previously-box'>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <h4 className="col-form-label mb-0">Show Previously Ignored Transactions:</h4>
                                                    <div className="dropdown-input-box">
                                                        <select className="dei-filter-select select-box arrow-box" onChange={this.HandleIgnored} value={this.state.IsIgnoredFilter} >
                                                            <option value={true}> YES </option>
                                                            <option value={false}> NO </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=''>
                                                <div className="form-group d-flex mb-0 align-items-center">
                                                    <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyIgnore()}>{this.state.IsIgnoredFilter ? "Revert" : "Got It"}</Button>
                                                    {/* Refresh Data button commented for Vendor Payee DEI.
                                                    <Button variant="contained" style={{ backgroundColor: this.state.ColorCode }} className="jr-btn text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                                    */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation use-vendor-payee-table">
                                    <thead>
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            <th className={`td-width ${this.state.sortField === 'date' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title">Date</p> </th>
                                            <th className={`td-width  ${this.state.sortField === 'transactionType' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}><p className="table-th-title">Type</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'payeeType' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('payeeType')}><p className="table-th-title">Payee Type</p> </th>
                                            {/* Payee Name after Payee Type (GL.Name). */}
                                            <th className={`td-width ${this.state.sortField === 'name' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Payee Name</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'account' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('account')}><p className="table-th-title">Account</p> </th>
                                            <th className={`td-width  text-right ${this.state.sortField === 'amount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title">Amount</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'memoOrDescription' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title">Memo/Description</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'accountantComment' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('accountantComment')}><p className="table-th-title">Questions and Comments</p> </th>
                                            <th className={`td-width ${this.state.sortField === 'newAccount' ? this.state.sortFormat === 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('newAccount')}><p className="table-th-title">New Account #</p> </th>
                                            <th className="text-center">
                                                <label className="container101 header-check">
                                                    <input className="second-check-box" type="checkbox" checked={!!this.state.SelectALL} onChange={(e) => this.SelectALL(e)} />
                                                    <span className="checkmark101 yellowMark white_border"></span>
                                                </label>
                                            </th>
                                            <th className="text-center">
                                                <div className="panel-commentCount" style={{ width: 'auto', display: 'inline-block', margin: 0, verticalAlign: 'middle' }}>
                                                    <img src="/vendors/WhiteCommnet.png" alt="comments" />
                                                </div>
                                            </th>
                                            <th className="text-center"><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.MissingData && this.state.MissingData.length > 0 ?
                                            this.state.MissingData.map((item, j) => (
                                                <React.Fragment key={j}>
                                                    <tr onClick={() => this.onRowClick(j, item)} className="dei-clickable">
                                                        <td title={item.date || ''}>{item.date}</td>
                                                        <td title={item.transactionType || ''}>{item.transactionType}</td>
                                                        <td title={item.payeeType || ''}>{item.payeeType}</td>
                                                        <td title={item.name || ''}>{item.name}</td>
                                                        <td title={item.account || ''}>{item.account}</td>
                                                        <td className="text-right" title={item.amount != null ? String(item.amount) : ''}>{numberWithCommas(item.amount)}</td>
                                                        <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                        <td title={item.accountantComment || ''}>{item.accountantComment}</td>
                                                        <td title={this.formatNewAccountLabel(item)}>{this.formatNewAccountLabel(item)}</td>
                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <label className="container101">
                                                                <input
                                                                    className="second-check-box"
                                                                    type="checkbox"
                                                                    checked={!!(this.state.SelectALL || (selectedItem.length > 0 && selectedItem.indexOf(item.id) > -1))}
                                                                    onChange={(e) => this.onCheckboxClick(e, item)}
                                                                />
                                                                <span className="checkmark101 green_CheckMark"></span>
                                                            </label>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                            <div className="panel-commentCount" style={{ width: 'auto', display: 'inline-block', margin: 0, verticalAlign: 'middle' }}>
                                                                <img src="/vendors/Vector Smart Object.png" alt="comments" className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} onClick={(e) => this.LoadComments(e, item)}></img>
                                                                {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted" style={{ top: '-10px', right: '-6px', left: 'auto' }}>{item.unreviewCommentCount}</span>}
                                                            </div>
                                                        </td>
                                                        <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="link" onClick={(e) => this.onLinkClick(e, item)}></img></td>
                                                    </tr>
                                                    {this.state.editIndex === j && this.state.editData &&
                                                        <tr className="editRowColor use-vendor-payee-edit-row">
                                                            <td colSpan="12" className="use-vendor-payee-edit-cell">
                                                                <div className="use-vendor-payee-edit-inner">
                                                                    <div className="use-vendor-payee-new-account-edit">
                                                                        <label>New Account #</label>
                                                                        <div className="use-vendor-payee-account-select-wrap">
                                                                            <RSelect
                                                                                name="NewAccountID"
                                                                                className="use-vendor-payee-account-select"
                                                                                classNamePrefix="uvp-select"
                                                                                value={this.state.selectedAccount}
                                                                                onChange={(e) => this.handalAccountDropdown(e)}
                                                                                options={this.state.DisplayAccounts}
                                                                                placeholder="Select"
                                                                                styles={{
                                                                                    control: (base) => ({ ...base, textAlign: 'left', width: '100%', minHeight: 38, height: 38 }),
                                                                                    valueContainer: (base) => ({ ...base, height: 38, paddingTop: 0, paddingBottom: 0 }),
                                                                                    indicatorsContainer: (base) => ({ ...base, height: 38 }),
                                                                                    singleValue: (base) => ({ ...base, textAlign: 'left', marginLeft: 0 }),
                                                                                    placeholder: (base) => ({ ...base, textAlign: 'left' }),
                                                                                    option: (base) => ({ ...base, textAlign: 'left' }),
                                                                                    menu: (base) => ({ ...base, textAlign: 'left' }),
                                                                                    input: (base) => ({ ...base, textAlign: 'left', margin: 0, padding: 0 }),
                                                                                    container: (base) => ({ ...base, width: '100%' })
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="use-vendor-payee-comment-edit">
                                                                        <label>Questions and Comments</label>
                                                                        <Textarea className="placheholder-color dei-note-input"
                                                                            value={this.state.editData.accountantComment} name="accountantComment"
                                                                            
                                                                            resize={"false"} placeholder=""
                                                                            onChange={(e) => this.handalTextArea(e)} />
                                                                    </div>
                                                                    <div className="use-vendor-payee-edit-actions">
                                                                        <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowSave(item)}>SAVE</Button>
                                                                        <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancel()}>CANCEL</Button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </React.Fragment>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="12" align="center">
                                                    No issues here! Keep up the good work!
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    </React.Fragment>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        accounts: state.accounts.accountsData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MARK_IGNORED_DATA,
        Revert_Ignored_DATA,
        LedgerUpdate,
        Accounts
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UseVendorPayeeForPayments);
